import React from "react";
import TransparentModal from "../../app/UI/Modal/TransparentModal";
import { closeModal } from "./modalActions";
import { connect } from "react-redux";

import KazangDailySalesReportSpinner from "../reports/Cachet/KazangDailySales/KazangDailySalesReportSpinner";

const actions = {
  closeModal,
};

const kazangDailySalesReportSpinnerModal = ({ closeModal }) => {
  return (
    <TransparentModal modalHeader="Please Wait...." onClose={closeModal}>
      <KazangDailySalesReportSpinner />
    </TransparentModal>
  );
};

export default connect(
  null,
  actions
)(kazangDailySalesReportSpinnerModal);
